"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  getClient: true,
  Client: true,
  getExistingClient: true,
  RswResponse: true,
  SessionData: true,
  StateUpdateData: true,
  getNamespaceKey: true
};
Object.defineProperty(exports, "Client", {
  enumerable: true,
  get: function get() {
    return _client["default"];
  }
});
Object.defineProperty(exports, "getExistingClient", {
  enumerable: true,
  get: function get() {
    return _getExistingClient["default"];
  }
});
Object.defineProperty(exports, "RswResponse", {
  enumerable: true,
  get: function get() {
    return _types.RswResponse;
  }
});
Object.defineProperty(exports, "SessionData", {
  enumerable: true,
  get: function get() {
    return _types.SessionData;
  }
});
Object.defineProperty(exports, "StateUpdateData", {
  enumerable: true,
  get: function get() {
    return _stateManager.StateUpdateData;
  }
});
Object.defineProperty(exports, "getNamespaceKey", {
  enumerable: true,
  get: function get() {
    return _misc.getNamespaceKey;
  }
});
exports.getClient = void 0;

var _client = _interopRequireDefault(require("./client"));

var _getExistingClient = _interopRequireDefault(require("./client/getExistingClient"));

var _globalizeApi = _interopRequireDefault(require("./globalizeApi"));

var _types = require("./types");

var _stateManager = require("./client/stateManager");

var _misc = require("./utils/misc");

var _logger = _interopRequireDefault(require("./utils/logger"));

var _baseEventWeb = require("./baseEventWeb");

Object.keys(_baseEventWeb).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _baseEventWeb[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _baseEventWeb[key];
    }
  });
});

var getClient = function getClient(optionsArg) {
  try {
    var options = {}; // Accepts string for backwards-compatibility

    if (typeof optionsArg === 'string') {
      options.namespace = optionsArg;
    } else if (optionsArg !== undefined) {
      options = optionsArg;
    }

    if (undefined && options.namespace !== 'global') {
      throw new Error('When using standalone script, getClient must be passed "global" as the namespace argument');
    } // Get client from previous instantiation or anew:


    var existingClient = (0, _getExistingClient["default"])(options.namespace);

    if (existingClient) {
      return existingClient;
    }

    var newClient = new _client["default"](); // Send client to the global scope, using namespace if provided

    (0, _globalizeApi["default"])(newClient, options.namespace);
    return newClient;
  } catch (e) {
    _logger["default"].error(e);

    return null;
  }
};

exports.getClient = getClient;

if (undefined && !(0, _misc.noWindow)()) {
  var majorRelease = "9";
  window["rsw".concat(majorRelease)] = {
    getClient: getClient
  };
}